import React, { useState } from 'react';

import { Alert, Box, Button, Grid, Stack, Typography } from '@mui/material';
import KpiComponent from '@/components/Base/KpiComponent';
import { useConsolidationSummary } from '@/features/dashboard/api/getConsolidationSummary.ts';
import CurrencyFormat from '@/utils/CurrencyFormat.ts';
import PeriodFilterDash from '@/components/Base/PeriodFilterDash';
import dayjs from 'dayjs';
import ImportCountDefault from '@/components/Base/ImportCountDefault';
import TableHeaderCustom from '@/components/Base/TableHeaderCustom';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import {
  getConsolidationSummaryStudents,
  useConsolidationSummaryStudents,
} from '@/features/dashboard/api/getConsolidationSummaryStudents';
import LoadingChart from '@/features/dashboard/components/LoadingChart';
import LoadingSummary from '@/features/dashboard/components/LoadingSummary';
import PeriodFilterYearMonthy from '@/components/Base/PeriodFilterYearMonthy';
import { TitlePages } from '@/components/Base/TitlePage';
import { useInadimplenciaHistoricalOverview } from '@/features/inadimplencia/api/getInadimplenciaHistoricalOverview';
import TableHeaderCustomTermometro from '@/components/Base/TableHeaderCustomTermometro';
import { useTermometroFinanceiroMetricasAlunos } from '@/features/termometro/getTermometroFinanceiroMetricasAlunos';
import { useTermometroGeralMetricasAlunos } from '@/features/termometro/getTermometroGeralMetricasAlunos';
import TableHeaderCustomTermometroGeral from '@/components/Base/TableHeaderCustomTermometroGeral';

const generateLastYears = (numYears) => {
  const currentYear = dayjs().year();
  return Array.from({ length: numYears }, (_, index) => currentYear - index).reverse();
};

export const TermometroConfiguracoesAvancadasGeral = ({ routeBack }) => {
  const startDate = dayjs().startOf('year').format('YYYY-MM-DD');
  const endDate = dayjs().endOf('month').format('YYYY-MM-DD');

  const [open, setOpen] = useState(false);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  // const { data: summary, isError, refetch, isFetching, isFetched } = useConsolidationSummary();
  
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [listYears, setListYears] = useState(generateLastYears(5));
  

  const daysDiff = dayjs(selectedEndDate).diff(dayjs(selectedStartDate), 'day') || null;

  const filters = {
    ...(selectedYear && { year: selectedYear }),
    ...(selectedMonth && { month: selectedMonth }),
    // ...(daysDiff !== null && { days: daysDiff }),
  };

  const { data: summary, isError, refetch, isFetching, isFetched } = useTermometroGeralMetricasAlunos(filters);



  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
  };

  const onApplyFilter = (selectedYear: number) => {
    setOpen(!!selectedYear);
  };

  return (
    <>
      <ImportCountDefault open={open} handleClose={handleClose} />

      <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
      <Stack flexDirection={'row'} alignItems={'center'}>
          <ArrowBack sx={{  cursor: 'pointer' }} onClick={() => navigate(routeBack)} />
          <TitlePages title={'Configurações avançadas/Termômetro geral'} />
        </Stack>
      </Stack>

      <Box
        padding={'15px'}
        sx={{
          border: '1px solid rgba(176, 176, 176, 1)',
          background: '#fff',
          borderRadius: '14px',
        }}
      >
        {isError && (
          <Alert
            severity="error"
            action={
              <Button
                color="inherit"
                size="small"
                onClick={() => {
                  refetch();
                }}
              >
                Atualizar
              </Button>
            }
          >
            Não foi possível carregar as informações!
          </Alert>
        )}

        <Box marginTop={'10px'} marginBottom={'25px'}>
        <PeriodFilterDash
          startDate={selectedStartDate}
          endDate={selectedEndDate}
          onStartDateChange={setSelectedStartDate}
          onEndDateChange={setSelectedEndDate}
          refetchDashboard={() => console.log('teste')}
          listYears={listYears}
          setSelectedYear={setSelectedYear}
          setSelectedMonth={setSelectedMonth}
          selectedYear={selectedYear}
          selectedMonth={selectedMonth}
          showPeriodFilter={false}
        />
        </Box>

        <LoadingChart loading={!summary} />
        {summary && (
          <TableHeaderCustomTermometroGeral
            data={summary || []}
            toBack={
              '/termometro-historico-geral'
            }
          />
        )}
      </Box>
    </>
  );
};
